import React, { useState } from 'react';

const EXPECTED = {
  theme: 'Dark',
  language: 'French',
  notifications: true,
  autoSave: '5 minutes',
  twoFactor: true,
  sessionTimeout: '30 minutes',
  defaultView: 'Compact',
};

function Row({ label, children }) {
  return (
    <div className="ab-settings-row">
      <span className="ab-settings-label">{label}</span>
      <div className="ab-settings-ctrl">{children}</div>
    </div>
  );
}

function Toggle({ name, checked, onChange, disabled }) {
  return (
    <label className="ab-toggle">
      <input type="checkbox" name={name} checked={checked} onChange={onChange} disabled={disabled} />
      <span className="ab-toggle-track"><span className="ab-toggle-thumb" /></span>
      <span className="ab-toggle-txt">{checked ? 'ON' : 'OFF'}</span>
    </label>
  );
}

export default function C02_SettingsForm({ onComplete }) {
  const [s, setS] = useState({
    theme: 'Light', language: 'English', notifications: false,
    autoSave: '15 minutes', twoFactor: false, sessionTimeout: '60 minutes', defaultView: 'Standard',
  });
  const [saved, setSaved] = useState(false);

  const ch = (e) => {
    const { name, value, type, checked } = e.target;
    setS(p => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSave = () => {
    setSaved(true);
    const results = {};
    let score = 0;
    for (const key of Object.keys(EXPECTED)) {
      const pass = s[key] === EXPECTED[key];
      results[key] = { expected: String(EXPECTED[key]), got: String(s[key]), pass };
      if (pass) score++;
    }
    const pct = Math.round((score / Object.keys(EXPECTED).length) * 100);
    onComplete({ score: pct, details: results, passed: pct === 100 });
  };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-settings-panel">
        <div className="ab-settings-section-title">Appearance</div>
        <Row label="Theme">
          <select name="theme" value={s.theme} onChange={ch} className="ab-input" disabled={saved}>
            {['Light', 'Dark', 'System'].map(v => <option key={v}>{v}</option>)}
          </select>
        </Row>
        <Row label="Language">
          <select name="language" value={s.language} onChange={ch} className="ab-input" disabled={saved}>
            {['English', 'French', 'German', 'Spanish', 'Japanese', 'Hindi'].map(v => <option key={v}>{v}</option>)}
          </select>
        </Row>
        <Row label="Default View">
          <select name="defaultView" value={s.defaultView} onChange={ch} className="ab-input" disabled={saved}>
            {['Standard', 'Compact', 'Comfortable'].map(v => <option key={v}>{v}</option>)}
          </select>
        </Row>

        <div className="ab-settings-section-title">Notifications & Automation</div>
        <Row label="Enable Notifications">
          <Toggle name="notifications" checked={s.notifications} onChange={ch} disabled={saved} />
        </Row>
        <Row label="Auto-save Interval">
          <select name="autoSave" value={s.autoSave} onChange={ch} className="ab-input" disabled={saved}>
            {['1 minute', '5 minutes', '10 minutes', '15 minutes', '30 minutes'].map(v => <option key={v}>{v}</option>)}
          </select>
        </Row>

        <div className="ab-settings-section-title">Security</div>
        <Row label="Two-Factor Authentication">
          <Toggle name="twoFactor" checked={s.twoFactor} onChange={ch} disabled={saved} />
        </Row>
        <Row label="Session Timeout">
          <select name="sessionTimeout" value={s.sessionTimeout} onChange={ch} className="ab-input" disabled={saved}>
            {['15 minutes', '30 minutes', '60 minutes', '120 minutes', 'Never'].map(v => <option key={v}>{v}</option>)}
          </select>
        </Row>
      </div>

      {!saved
        ? <button className="ab-action-btn" onClick={handleSave}>Save Settings</button>
        : <div className="ab-submitted-badge">✓ Settings Saved — Evaluating...</div>
      }
    </div>
  );
}
